var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3499 5.39598L11.9961 0.14598C11.9014 0.0530657 11.7718 0 11.6362 0H2.52964C1.68628 0 1 0.672986 1 1.5V21.5C1 22.327 1.68628 23 2.52964 23H15.9704C16.8137 23 17.5 22.327 17.5 21.5L17.4998 5.75014C17.4998 5.61705 17.4458 5.49006 17.3499 5.39598ZM12.146 1.70692L15.7591 5.25001H12.146V1.70692ZM15.9701 22.0001H2.52983C2.24934 22.0001 2.01989 21.7761 2.01989 21.5V1.50001C2.01989 1.22395 2.24934 0.999951 2.52983 0.999951H11.1264V5.74981C11.1264 6.02587 11.3548 6.24987 11.6363 6.24987H16.4801V21.5C16.4801 21.7761 16.2506 22.0001 15.9701 22.0001Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24978 8.71387C6.63917 8.71387 4.51489 10.7968 4.51489 13.357C4.51489 15.917 6.63899 18.0002 9.24978 18.0002C11.8606 18.0002 13.9847 15.9172 13.9847 13.357C13.9847 10.797 11.8606 8.71387 9.24978 8.71387ZM9.24978 16.9999C7.20116 16.9999 5.53477 15.3659 5.53477 13.3568C5.53477 11.3489 7.20098 9.71381 9.24978 9.71381C11.2984 9.71381 12.9648 11.3477 12.9648 13.3568C12.9648 15.3658 11.2984 16.9999 9.24978 16.9999Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4762 12.8569H9.75999V11.1739C9.75999 10.8978 9.53156 10.6738 9.25005 10.6738C8.96853 10.6738 8.74011 10.8978 8.74011 11.1739V12.8569H7.02385C6.74234 12.8569 6.51392 13.0809 6.51392 13.3569C6.51392 13.633 6.74234 13.857 7.02385 13.857L8.74011 13.8568V15.5398C8.74011 15.8159 8.96853 16.0399 9.25005 16.0399C9.53156 16.0399 9.75999 15.8159 9.75999 15.5398V13.8568H11.4762C11.7578 13.8568 11.9862 13.6328 11.9862 13.3568C11.986 13.0809 11.7576 12.8569 11.4762 12.8569V12.8569Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFileIcon);
export default __webpack_public_path__ + "static/media/add_file_icon.d67cccd186528ab2f41b00d9d0f3e256.svg";
export { ForwardRef as ReactComponent };